import type {
  DraftDashboardTile,
  HydratedDashboardContentAvailable,
  HydratedDashboardContentUnavailable,
} from './utils/dashboard.types';

export function isHydratedAvailable(
  tile: DraftDashboardTile
): tile is HydratedDashboardContentAvailable {
  return 'content' in tile && tile.content != null;
}

export function isUnavailableTile(
  tile: DraftDashboardTile
): tile is HydratedDashboardContentUnavailable {
  return 'unavailable' in tile && tile.unavailable === true;
}
